import React, {Component} from 'react';
import * as firebase from 'firebase';
import MetaTags from 'react-meta-tags';
import ReactDom from 'react-dom';
import ReactQuill from 'react-quill';
import AvatarCropper from "react-avatar-cropper";
import 'react-quill/dist/quill.snow.css';

export default class AuthorityPost extends Component {
  constructor() {
    super();
    this.state = {
      blogName: '',
      blogTag: '報健康',
      secondTag: '亞健康',
      listPhoto: '',
      description: '',
      author: '',
      authorUrl: '',
      value: '',
      otherTag1: '',
      otherTag2: '',
      cropperOpen: false,
      img: null,
      croppedImg: "",
      canReload: false
    }
    this.handleChangeBlogName = this.handleChangeBlogName.bind(this);
    this.handleChangeDescription = this.handleChangeDescription.bind(this);
    this.handleChangeBlogTag = this.handleChangeBlogTag.bind(this);
    this.handleChangeSecondTag = this.handleChangeSecondTag.bind(this);
    this.handleChangeOtherTag1 = this.handleChangeOtherTag1.bind(this);
    this.handleChangeOtherTag2 = this.handleChangeOtherTag2.bind(this);
    this.handleChangeEnTag = this.handleChangeEnTag.bind(this);
    this.handleChangeListPhoto = this.handleChangeListPhoto.bind(this);
    this.handleChangeAuthor = this.handleChangeAuthor.bind(this);
    this.handleChangeAuthorUrl = this.handleChangeAuthorUrl.bind(this);
    this.onChange = this.onChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleCrop = this.handleCrop.bind(this);
    this.handleRequestHide = this.handleRequestHide.bind(this);
    this.handlePushTo = this.handlePushTo.bind(this);
    this.handleCancelPushTo = this.handleCancelPushTo.bind(this);
  }
  
  componentDidMount() {
    window.scrollTo(0,0)
    const userId = firebase.auth().currentUser.uid
    const getNameRef = firebase.database().ref('medicalTeam/').child(userId);
    getNameRef.on('value', snap => {
      this.setState({
        name: snap.val().name
      })
    })
  }

  onChange(value) {
    this.setState({value: value})
  }

  handleChangeBlogName(event) {
    this.setState({blogName: event.target.value})
  }
  handleChangeDescription(event) {
    this.setState({description:event.target.value})
  }
  handleChangeBlogTag(event) {
    this.setState({blogTag: event.target.value})
  }

  handleChangeSecondTag(event) {
    this.setState({secondTag: event.target.value})
  }

  handleChangeOtherTag1(event) {
    this.setState({otherTag1: event.target.value})
  }

  handleChangeOtherTag2(event) {
    this.setState({otherTag2: event.target.value})
  }

  handleChangeEnTag(event) {
    this.setState({enTag: event.target.value})
  }

  handleChangeAuthor(event) {
    this.setState({author: event.target.value})
  }

  handleChangeAuthorUrl(event) {
    this.setState({authorUrl: event.target.value})
  }

  handleChangeListPhoto(event) {
    this.setState({listPhoto: event.target.value})
  }
  handleFileChange(dataURI) {
    this.setState({
      img: dataURI,
      croppedImg: this.state.croppedImg,
      cropperOpen: true
    });
  }
  handleCrop(dataURI) {
    this.setState({
      cropperOpen: false,
      img: null,
      croppedImg: dataURI
    });
  }
  handleRequestHide() {
    this.setState({
      cropperOpen: false
    });
  }
  handlePushTo() {
     window.location = ('/UserProfile/AuthorityDraftTable');
  }
  handleCancelPushTo() {
    window.location = ('/UserProfile/AuthorityPost')
  }
  handleSave(event, value) {
    
    const userId = firebase.auth().currentUser.uid;
    const postRef = firebase.database().ref('authorityPostsDraft/').push()
    const postId = postRef.key
    postRef.update({
      blogName: this.state.blogName,
      description: this.state.description,
      blogTag: this.state.blogTag,
      secondTag: this.state.secondTag,
      otherTag1: this.state.otherTag1 ? this.state.otherTag1 : null,
      otherTag2: this.state.otherTag2 ? this.state.otherTag2 : null,
      croppedImg: this.state.croppedImg ? this.state.croppedImg : null,
      author: this.state.author ? this.state.author : null,
      authorUrl: this.state.authorUrl ? this.state.authorUrl : null,
      createDate: new Date().toLocaleDateString(),
      createTime: new Date().toLocaleTimeString(),
      value: this.state.value ? this.state.value : null,
      id: postId,
      userId: userId,
      name: this.state.name
    })
    this.setState({canReload: true})
    event.preventDefault()
  }

  render() {
    const modules = {
      toolbar: [
        [{ 'header': [1, 2, false] }],
        ['bold', 'italic', 'underline','strike', 'blockquote'],
        [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
        ['link', 'image'],
        ['clean']
      ],
    }
    const formats = [
      'header',
      'bold', 'italic', 'underline', 'strike', 'blockquote',
      'list', 'bullet', 'indent',
      'link', 'image'
    ]
    const tagItems = [
      '報健康','吃營養','好運動', '樂旅遊'
    ].map((tagItem) => {
      return <option key={tagItem} value={tagItem}>{tagItem}</option>
    })
    const secondTagItems = [
      '亞健康',
      '過勞',
      '自我肯定',
      '失眠',
      '壓力',
      '憂鬱',
      '尼古丁',
      '趴趴熊',
      '飲食',
      '平和質',
      '氣虛質',
      '陽虛質',
      '陰虛質',
      '痰濕質',
      '濕熱質',
      '血瘀質',
      '氣鬱質',
      '特稟質',
      '其他'
    ].map((secondTagItem) => {
      return <option key={secondTagItem} value={secondTagItem}>{secondTagItem}</option>
    })
    const otherTagItems = [
      '',
      '亞健康建議飲食',
      '過勞建議飲食',
      '失眠建議飲食',
      '壓力建議飲食',
      '憂鬱建議飲食',
      '戒菸建議飲食',
      '趴趴熊建議飲食',
      '飲食行為',
      '平和質建議飲食',
      '氣虛質建議飲食',
      '陽虛質建議飲食',
      '陰虛質建議飲食',
      '痰濕質建議飲食',
      '濕熱質建議飲食',
      '血瘀質建議飲食',
      '氣鬱質建議飲食',
      '特稟質建議飲食'
    ].map((otherTagItem) => {
      return <option key={otherTagItem} value={otherTagItem}>{otherTagItem}</option>
    })

    
    return(
      <div>
        <MetaTags>
            <title>草學藥事 || 新增專欄文章</title>
            <meta id="og-title" property="og:title" content="新增專欄文章" />
        </MetaTags>
       <h1 style={{marginBottom: 5}} >新增專欄文章</h1>
       <small style={{color: 'rgb(255,50,50)', fontSize: 12}} >新增文章禁止文章內有任何以下行為: 若經檢舉屬實會刪除此篇文章,嚴重累犯者取消平台權限使用資格<br/>
        1.捏造事實<br />
        2.抄襲(若要引用請確實填寫引用作者以及文章出處)<br />
        3.謾罵(平台內禁止任何爭論性文章討論)<br />
        4.廣告(任何廣告行為, 需向平台申請, 不可在文章內直接發布)
       </small>
       <div className="postForm">
       <form onSubmit={this.handleSave} >
        <div className="container-fluid">
         <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 paddLeftAuto">
           <div className="group">
            <label htmlFor="blogName">*標題:</label>
            <input type="text" id="blogName" value={this.state.blogName} onChange={this.handleChangeBlogName} required="true" placeholder="請輸入標題" />
           </div>
           <div className="group">
            <label htmlFor="description">*簡述:</label>
            <input type="text" id="description" value={this.state.description} onChange={this.handleChangeDescription} required="true" placeholder="請輸入文章簡述" />
           </div>
           <div className="group">
            <label htmlFor="blogTag">*主分類:</label>
            <select value={this.state.blogTag} onChange={this.handleChangeBlogTag} id="blogTag">
             {tagItems}
            </select>
           </div>
           <div className="group">
            <label htmlFor="secondTag">*次分類:</label>
            <select value={this.state.secondTag} onChange={this.handleChangeSecondTag} id="secondTag">
             {secondTagItems}
            </select>
           </div>
           <div className="group">
           <label htmlFor="otherTag1">其他分類:</label>
            <select value={this.state.otherTag1} onChange={this.handleChangeOtherTag1} id="otherTag1">
             {otherTagItems}
            </select>
           </div>
           <div className="group" style={Jeyu.Flex}>
             <span>
              <label htmlFor="otherTag2">其他分類:</label>
              <input type="text" id="otherTag2" value={this.state.otherTag2} onChange={this.handleChangeOtherTag2}  placeholder="請輸入標籤" />
             </span>
           </div>
           <div className="group">
            <label htmlFor="author">文章出處作者<small>(引用文章時請確實填寫)</small>:</label>
            <input type="text" id="author" value={this.state.author} onChange={this.handleChangeAuthor} placeholder="請輸入出處作者" />
           </div>
           <div className="group">
            <label htmlFor="authorUrl">文章出處連結<small>(引用文章時請確實填寫)</small>:</label>
            <input type="text" id="authorUrl" value={this.state.authorUrl} onChange={this.handleChangeAuthorUrl} placeholder="請輸入出處連結" />
           </div>
           <div className="group listPhoto">
            <div className="avatar-photo">
             <img src={this.state.croppedImg} alt="縮圖" style={{display: this.state.croppedImg ? 'block' : 'none'}} />
             <label htmlFor="listPhoto" >給文章一個美麗的縮圖吧~:<small style={{color: 'rgb(255, 60, 120)'}}>*圖片大小200kb以內</small></label>
             <FileUpload handleFileChange={this.handleFileChange} />
              <div className="avatar-edit">
               <i className="fa fa-camera"></i>
              </div> 
            </div>
            {this.state.cropperOpen &&
             <AvatarCropper
              onRequestHide={this.handleRequestHide}
              cropperOpen={this.state.cropperOpen}
              onCrop={this.handleCrop}
              image={this.state.img}
              width={400}
              height={260}
             />
            }
           </div>
           <div className="group">
            <label>*文章內容</label>
           <ReactQuill value={this.state.value}
                  onChange={this.onChange}
                  modules={modules}
                  formats={formats}
                   />
           </div>
          </div>
         </div>
        </div>
        <input type="submit" value="儲存草稿" className="btnDefault"/>
       </form>
       <div className="lightBox" style={{display: this.state.canReload ? 'flex' : 'none'}}>
              <form className="reportBox">
               <p>您的文章已經儲存為草稿了,可在草稿內確認最後修改與正式發佈到前台或刪除</p>
               <span className="btnDefault" onClick={this.handlePushTo}>前往管理草稿</span>
               <span className="btnDefault" onClick={this.handleCancelPushTo}>取消</span>
              </form>
             </div>
       </div>
      </div>
    )
  }
}
class FileUpload extends Component {
  constructor() {
    super();
    this.handleFile = this.handleFile.bind(this)
  }
  handleFile(e) {
    var reader = new FileReader();
    var file = e.target.files[0];

    if (!file) return;

    reader.onload = function(img) {
      ReactDom.findDOMNode(this.refs.in).value = '';
      this.props.handleFileChange(img.target.result);
    }.bind(this);
    reader.readAsDataURL(file);
  }
  render() {
     return(
      <input ref="in" type="file" accept="image/*" onChange={this.handleFile} />  
     )
  }
}
const Jeyu = {
  Flex: {
    display: 'flex',
    flex:1
  }
}


// WEBPACK FOOTER //
// ./src/post/AuthorityPost.js